import { z } from "zod";

export const AilmentSchema = z.enum(["fall_prevention", "joint_pain", "osteoporosis"]);
export type Ailment = z.infer<typeof AilmentSchema>;

export const LateralLocationSchema = z.enum(["left", "right", "undefined"]);
export type LateralLocation = z.infer<typeof LateralLocationSchema>;

export const LocationSchema = z.enum([
  "elbow",
  "foot",
  "hand",
  "hip",
  "jaw",
  "knee",
  "lower_back",
  "lower_leg",
  "neck",
  "shoulder",
  "spine",
  "upper_back",
  "wrist",
]);
export type Location = z.infer<typeof LocationSchema>;

const PainLocationSchema = z.object({
  lateral_location: LateralLocationSchema,
  location: LocationSchema,
});
export type PainLocation = z.infer<typeof PainLocationSchema>;

export const TreatmentTypeSchema = z.enum(["digital", "hep", "hybrid", "non_rtm", "not_used", "rtm"]);
